// Mirrors the Hub's `GET /auth/account/deletion-preview` payload — what a
// self-service account deletion would entail for the current user.
//
// See agent-os/specs/2026-05-29-account-deletion/spec.md. Web counterpart of
// crop-swipe/lib/models/account_deletion.dart — keep field names + types in
// sync if either side ever changes.

/** An active commitment that hard-blocks deletion until resolved. */
export interface DeletionBlocker {
  type: string;
  count: number;
}

/** Lightweight org reference (id + name) used in the preview lists. */
export interface OrgRef {
  id: string;
  name: string;
}

export interface AccountDeletionPreview {
  canDelete: boolean;
  blockers: DeletionBlocker[];

  /** Owned orgs with other members — the user must hand off ownership first. */
  orgsNeedingReassignment: OrgRef[];

  /** Owned orgs where the user is the only member — closed with the account. */
  orgsToBeClosed: OrgRef[];
}

/**
 * Human-readable noun for a blocker (used in "You have N …"). Matches the
 * mobile `DeletionBlocker.label` getter so the two surfaces speak the same
 * language to the user.
 */
export function deletionBlockerLabel(blocker: DeletionBlocker): string {
  switch (blocker.type) {
    case 'active_work_orders':
      return blocker.count === 1 ? 'active work order' : 'active work orders';
    case 'pending_bids':
      return blocker.count === 1 ? 'pending or accepted bid' : 'pending or accepted bids';
    case 'active_drone_assignments':
      return blocker.count === 1 ? 'active drone assignment' : 'active drone assignments';
    default:
      return blocker.type.replace(/_/g, ' ');
  }
}
